/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_ApprovalInputs */

const en_mk_cmp_r_approval = /** @type {(inputs: Mk_Cmp_R_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fence before outbound actions`)
};

const id_mk_cmp_r_approval = /** @type {(inputs: Mk_Cmp_R_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagar sebelum aksi keluar`)
};

/**
* | output |
* | --- |
* | "A fence before outbound actions" |
*
* @param {Mk_Cmp_R_ApprovalInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_approval = /** @type {((inputs?: Mk_Cmp_R_ApprovalInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_ApprovalInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_approval(inputs)
	return en_mk_cmp_r_approval(inputs)
});